import Page from "components/base/Page";
import { Navigate, Route, Routes } from "react-router-dom";
import Products from "./Products";

const ProductionAnalytics = () => {
  return (
    <Page title="Production Analytics">
      <Routes>
        <Route path="products" element={<Products />} />
        <Route path="*" element={<Navigate to="products" />} />
      </Routes>
    </Page>
  );
};

export default ProductionAnalytics;
